export default {
	CIRCLE: 1,
	POLYGON: 2,
};
